import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=0493132f&scoped=true&"
import script from "./accordion-item.vue?vue&type=script&lang=js&"
export * from "./accordion-item.vue?vue&type=script&lang=js&"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=0493132f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0493132f",
  null
  
)

export default component.exports